import { render, staticRenderFns } from "./ProfilePaymentWallet.vue?vue&type=template&id=a902e5ec&scoped=true&"
import script from "./ProfilePaymentWallet.vue?vue&type=script&lang=js&"
export * from "./ProfilePaymentWallet.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePaymentWallet.vue?vue&type=style&index=0&id=a902e5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a902e5ec",
  null
  
)

export default component.exports